"use client";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { cn } from "@/lib/utils";

interface CardWrapperProps {
  children?: React.ReactNode;
  backButtonLabel?: string;
  backButtonHref?: string;
  className?: string;
}

export function CardWrapper({
  children,
  backButtonLabel,
  backButtonHref,
  className,
}: CardWrapperProps) {
  return (
    <Card className={cn("w-[400px] shadow-none border-none sm:shadow-md sm:border", className)}>
      <CardContent>{children}</CardContent>

      <CardFooter></CardFooter>

      {backButtonLabel && backButtonHref && (
        <CardFooter>
          <Link href={backButtonHref}>
            <Button asChild variant="link" size="sm" className="w-full font-normal">
              {backButtonLabel}
            </Button>
          </Link>
        </CardFooter>
      )}
    </Card>
  );
}
